import { Component, OnDestroy, Signal } from '@angular/core';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { TrafficOrganizationProjectForm } from './forms/traffic-organization-project.form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { DatePickerComponent } from '../../../../../../common/date-picker/date-picker.component';
import { updateApplication, updateParcels } from '../../../../../../store/actions/application.actions';
import { stages } from '../../opinion-on-the-project-of-traffic-org.routes';

@Component({
  selector: 'app-traffic-organization-project-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    CommonModule,
    DatePickerComponent
  ],
  providers: [TrafficOrganizationProjectForm],
  templateUrl: './traffic-organization-project-section.component.html'
})
export class TrafficOrganizationProjectSectionComponent implements OnDestroy {

  public stages = stages;

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private router: Router,
    public form: TrafficOrganizationProjectForm
  ) {
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(
        updateApplication({
          id: this.application()?.uuid || '',
          application: this.form.toWriteModel(),
          successFnc: (applicationId: string) => {
            this.router.navigate(
              ['../lokalizacja'],
              {
                relativeTo: this.route
              }
            );
          },
          failureFnc: () => {
          }
        })
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
